/**
 * Phone mask for Russian phone numbers
 * Formats input as: +7 (XXX) XXX-XX-XX
 */

export function initPhoneMask(): void {
  const phoneInputs = document.querySelectorAll<HTMLInputElement>('input[type="tel"][name="phone"]');

  phoneInputs.forEach((input) => {
    // Format phone number on input
    input.addEventListener('input', (e: Event) => {
      const target = e.target as HTMLInputElement;
      let value = target.value.replace(/\D/g, ''); // Remove all non-digits

      // Limit to 11 digits (10 digits + country code)
      if (value.length > 11) {
        value = value.slice(0, 11);
      }

      // Format based on length
      let formatted = '';
      if (value.length === 0) {
        formatted = '';
      } else if (value.length <= 1) {
        // If starts with 8, keep it; otherwise add +7
        if (value === '8') {
          formatted = '8';
        } else {
          formatted = '+7';
          if (value !== '7') {
            formatted += value;
          }
        }
      } else {
        // Convert 8 to +7
        if (value[0] === '8') {
          value = '7' + value.slice(1);
        } else if (value[0] !== '7') {
          value = '7' + value;
        }

        // Format: +7 (XXX) XXX-XX-XX
        if (value.length <= 1) {
          formatted = '+7';
        } else if (value.length <= 4) {
          formatted = `+7 (${value.slice(1)}`;
        } else if (value.length <= 7) {
          formatted = `+7 (${value.slice(1, 4)}) ${value.slice(4)}`;
        } else if (value.length <= 9) {
          formatted = `+7 (${value.slice(1, 4)}) ${value.slice(4, 7)}-${value.slice(7)}`;
        } else {
          formatted = `+7 (${value.slice(1, 4)}) ${value.slice(4, 7)}-${value.slice(7, 9)}-${value.slice(9, 11)}`;
        }
      }

      target.value = formatted;
    });

    // Handle backspace to allow proper deletion
    input.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Backspace') {
        const target = e.target as HTMLInputElement;
        const cursorPosition = target.selectionStart || 0;
        
        // If cursor is at a position with a separator, move it back
        if (cursorPosition > 0) {
          const charBefore = target.value[cursorPosition - 1];
          if ([' ', '(', ')', '-'].includes(charBefore)) {
            e.preventDefault();
            target.setSelectionRange(cursorPosition - 1, cursorPosition - 1);
            // Trigger input event to reformat
            target.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    });

    // Handle paste
    input.addEventListener('paste', (e: ClipboardEvent) => {
      e.preventDefault();
      const pastedText = (e.clipboardData?.getData('text') || '').replace(/\D/g, '');
      const target = e.target as HTMLInputElement;
      
      // Convert 8 to 7 if needed
      let value = pastedText;
      if (value[0] === '8') {
        value = '7' + value.slice(1);
      } else if (value[0] !== '7' && value.length > 0) {
        value = '7' + value;
      }

      // Limit to 11 digits
      if (value.length > 11) {
        value = value.slice(0, 11);
      }

      // Format and set value
      let formatted = '';
      if (value.length <= 1) {
        formatted = '+7';
      } else if (value.length <= 4) {
        formatted = `+7 (${value.slice(1)}`;
      } else if (value.length <= 7) {
        formatted = `+7 (${value.slice(1, 4)}) ${value.slice(4)}`;
      } else if (value.length <= 9) {
        formatted = `+7 (${value.slice(1, 4)}) ${value.slice(4, 7)}-${value.slice(7)}`;
      } else {
        formatted = `+7 (${value.slice(1, 4)}) ${value.slice(4, 7)}-${value.slice(7, 9)}-${value.slice(9, 11)}`;
      }

      target.value = formatted;
      
      // Move cursor to end
      setTimeout(() => {
        target.setSelectionRange(formatted.length, formatted.length);
      }, 0);
    });

    // Set placeholder to show format
    if (!input.placeholder || input.placeholder === '+7 (999) 123-45-67') {
      input.placeholder = '+7 (999) 123-45-67';
    }
  });
}

